import { ExpertRole, Language, NewEntityId, Switzerland, ValidationFields } from "../../data/constants";
import { ExpertMeViewModel } from "../../model/ExpertMeViewModel";
import { ExpertViewModel } from "../../model/ExpertViewModel";

export interface RequiredExpert {
  isFirstnameEmpty: boolean;
  isLastnameEmpty: boolean;
  isGenderEmpty: boolean;
  isBirthDateEmpty: boolean;
  isAhvNoEmpty: boolean;
  isEmailEmpty: boolean;
  isMobileNoEmpty: boolean;
  isBankAccountEmpty: boolean;
  isStreetEmpty: boolean;
  isStreetNumberEmpty: boolean;
  isZipCodeEmpty: boolean;
  isCityEmpty: boolean;
  isCountryEmpty: boolean;
  isLanguageEmpty: boolean;
  hasEmptyRoleArray: ExpertRole[];
  hasEmptyRole: boolean;
}

export const initialRequiredFields = (): RequiredExpert => ({
  isFirstnameEmpty: false,
  isLastnameEmpty: false,
  isGenderEmpty: false,
  isBirthDateEmpty: false,
  isEmailEmpty: false,
  isStreetEmpty: false,
  isStreetNumberEmpty: false,
  isZipCodeEmpty: false,
  isCityEmpty: false,
  isCountryEmpty: false,
  isLanguageEmpty: false,
  isAhvNoEmpty: false,
  isMobileNoEmpty: false,
  isBankAccountEmpty: false,
  hasEmptyRoleArray: [],
  hasEmptyRole: false,
});

export const emptyExpertViewModel: ExpertViewModel = {
  birthdate: new Date(),
  correspondenceLanguage: Language.DE,
  emailAddress: "",
  city: "",
  gender: "",
  bankAccount: "",
  mobileNumber: "",
  firstName: "",
  phoneNumber: "",
  id: NewEntityId,
  lastName: "",
  street: "",
  streetNumber: "",
  zipCode: "",
  languages: [],
  country: Switzerland,
  rolesWithExamsAndCourseTypes: [],
};

export const initialValidationFields: ValidationFields = {
  isAhvValid: false,
  isCiceroValid: false,
  isEmailValid: false,
  isMobileValid: false,
  isPhoneValid: false,
};

export const initialExpertMe: ExpertMeViewModel = {
  birthdate: new Date(),
  correspondenceLanguage: Language.DE,
  emailAddress: "",
  city: "",
  gender: "",
  bankAccount: "",
  mobileNumber: "",
  firstName: "",
  phoneNumber: "",
  id: "",
  lastName: "",
  street: "",
  streetNumber: "",
  zipCode: "",
  country: Switzerland,
  rolesWithExamsAndCourseTypes: [],
};

export const rolesWithRequiredExamOrCourseTypeAssignements: ExpertRole[] = [
  ExpertRole.Aufsichtsexperten,
  ExpertRole.Prüfungsexperten,
];

export const rolesAssignedToCourseTypes: ExpertRole[] = [ExpertRole.Aufsichtsexperten];
